export default __webpack_public_path__ + "static/media/service_list4.cd83473f.png";